/* eslint-disable no-console */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { HelmetProvider } from 'react-helmet-async';

import store from 'store';
import CustomAlert from 'components/CustomAlert';
import App from './App';

const persistor = persistStore(store);
const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

// Handler global para erros não capturados
window.addEventListener('error', (event) => {
  console.error('Erro global capturado:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });
  // Previne que o erro apareça no console como "Script error"
  if (event.error) {
    event.preventDefault();
  }
});

// Handler global para promessas rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  console.error('Promise rejeitada não tratada:', event.reason);
  // Previne que o erro apareça no console como "Script error"
  event.preventDefault();
});

const MainComponents = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              Components={{ customAlert: CustomAlert }}
            >
              <App />
            </SnackbarProvider>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

root.render(
  process.env.REACT_APP_ENVIRONMENT === 'local' ? (
    <React.StrictMode>
      <MainComponents />
    </React.StrictMode>
  ) : (
    <MainComponents />
  ),
);
